function getUrlParams( url ) {
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
}

function redirectUrl( url, urlParametrs ) {
    var x = 0;
    console.log(url);

    for(var index in urlParametrs) {
        if ( x === 0 ) {
            url = url +'?' + index + '=' + urlParametrs[index];
        }else{
            url = url +'&' + index + '=' + urlParametrs[index];
        }
        x++;
        console.log(url);
    }

    return url;
}


$(function(){
    $('.input__select select').change( function () {
        var select = $(this);
        var select_value = select.val();
        var data_attribute = select.data('get');

        var url = window.location.href;
        var exitingUrlParameters = getUrlParams(url);

        var urlKeys = Object.keys(exitingUrlParameters);

        var urlToRedirect;

        console.log(exitingUrlParameters);
        
        if ( exitingUrlParameters[data_attribute] ) {
            urlKeys.forEach(function(key) {
                if ( key == data_attribute ){
                    exitingUrlParameters[data_attribute] = select_value;
                }
            });
        }else{
            exitingUrlParameters[data_attribute] = select_value;
        }

        if ( urlKeys.length >= 2 ){

            console.log( 'Two and more parameters detected in current url' );

            url = location.protocol + '//' + location.host + location.pathname;
            urlToRedirect = redirectUrl( url, exitingUrlParameters );

            window.location = urlToRedirect;

        } else if ( urlKeys.length === 1 ){

            if ( exitingUrlParameters[''] === 'undefined' ){

                console.log( 'There is no parameters in current url' );

                window.location = url + '?' + data_attribute + '=' + select_value;

            } else {

                url = location.protocol + '//' + location.host + location.pathname;
                urlToRedirect = redirectUrl( url, exitingUrlParameters );

                window.location = urlToRedirect;

                console.log( 'One parameter detected in current url' );
                console.log(urlToRedirect);

            }
        }

        // if (url) { // require a URL
        //     window.location = url; // redirect
        // }
    });
});


// WEBPACK FOOTER //
// ./js/dev/filter.js